"use strict";

var KEYCODE_DOWN = 40;
var KEYCODE_UP = 38;
var KEYCODE_RETURN = 13;
var KEYCODE_ESCAPE = 27;

function getDefaultRadius(radiusSelect, postalCodeInput) {
    return (
        radiusSelect ? radiusSelect.getAttribute("data-default-value") :
        postalCodeInput ? postalCodeInput.getAttribute("data-default-radius") :
        undefined
    ) || "200";
}

var setup = function (pageFlavour) {
    var core = require("../helpers/core");
    var country = require("../helpers/country");

    var zipElem = document.querySelector("#home-" + pageFlavour + "-zip");
    var suggestionsListElem = document.querySelector("#home-" + pageFlavour + "-zip-suggestions-list");
    var countryDrdElem = document.querySelector("#home-" + pageFlavour + "-country");
    var radiusDrdElem = document.querySelector("#home-" + pageFlavour + "-zipr");
    var geoLatElem = document.querySelector("#home-" + pageFlavour + "-lat");
    var geoLonElem = document.querySelector("#home-" + pageFlavour + "-lon");
    var defaultRadius = getDefaultRadius(radiusDrdElem, zipElem);

    var authKey = "Y2xhc3NpZmllZC1saXN0LWpzOjg4NDY1NmY2NTc2NWRjMjQwZjMwY2FmODM5Mzk3NGE2";
    var autoCompleteServiceUrl = "https://geocode.a.autoscout24.com/autocomplete/";
    var latLonResolutionServiceUrl = "https://geocode.a.autoscout24.com/resolution/";

    var listSuggestionSelectedCssClass = "selected";
    var suggestionSelected = false;

    var isAutoSuggestActiveForDocumentCountry = function() {
        return country.isOneOf(["at", "de"]);
    };

    var triggerCounterUpdate = function () {
        core.dispatchCustomEvent("searchMaskChanged");
        core.dispatchCustomEvent("counterUpdateRequested");
    };

    var isSuggestionsListVisible = function () {
        return !suggestionsListElem.classList.contains("hidden");
    };

    var hideSuggestions = function () {
        suggestionsListElem.classList.add("hidden");
    };

    var showSuggestions = function () {
        suggestionsListElem.classList.remove("hidden");
        suggestionSelected = false;
    };

    var suggestionsAreHidden = function () {
        return suggestionsListElem.classList.contains("hidden");
    };

    var disableRadius = function(){
        if(radiusDrdElem){
            radiusDrdElem.value = "0";
            radiusDrdElem.disabled = true;
        }
    };

    var updateRadius = function(){
        if(radiusDrdElem && radiusDrdElem.disabled){
            radiusDrdElem.disabled = false;
            radiusDrdElem.value = defaultRadius;
        }
    };

    var resetSuggestions = function () {
        suggestionsListElem.innerHTML = "";
        hideSuggestions();
        geoLatElem.value = "";
        geoLonElem.value = "";
        disableRadius();
    };

    var isSelectedCountryEqualDocumentCountry = function () {
        return countryDrdElem[countryDrdElem.selectedIndex].value === country.asDropDownValue();
    };

    var fetchSuggestionsHandler = function (results) {
        if (results && results.suggestions) {
            resetSuggestions();
            for (var i = 0; i < Math.min(10, results.suggestions.length); i++) {
                var suggestion = results.suggestions[i];
                var listItem = document.createElement("li");
                listItem.textContent = suggestion.suggestion;
                if (i === 0) {
                    listItem.classList.add(listSuggestionSelectedCssClass);
                }
                listItem.setAttribute("data-suggestion-id", suggestion.id);
                suggestionsListElem.appendChild(listItem);
            }
            showSuggestions();
        }
    };

    var fetchSuggestionsErrorHandler = function () {
        resetSuggestions();
    };

    var fetchSuggestions = function (zipValue) {
        var url = autoCompleteServiceUrl + country.get() + "/" + zipValue;
        core.ajax(url, "GET", fetchSuggestionsHandler, "text/plain", false, fetchSuggestionsErrorHandler, {"Authorization": "Basic " + authKey});
    };

    var previousZipValue;
    var zipAutoSuggest = function (zipValue) {
        if (zipValue.length === 0) {
            hideSuggestions();
        } else {
            if (zipValue === previousZipValue && suggestionsListElem.childNodes.length > 0) {
                showSuggestions();
            } else {
                fetchSuggestions(zipValue);
                previousZipValue = zipValue;
            }
        }
    };



    var fetchLatLonHandler = function (result) {
        if (result) {
            geoLatElem.value = result.lat;
            geoLonElem.value = result.lon;
            updateRadius();
        }
        triggerCounterUpdate();
    };



    var fetchLatLon = function (suggestionId) {
        var url = latLonResolutionServiceUrl + country.get() + "/" + suggestionId;
        core.ajax(url, "GET", fetchLatLonHandler, "text/plain", false, null, {"Authorization": "Basic " + authKey});
    };

    var selectDocumentCountryInDropdown = function () {
        var countryAsDropDrownValue = country.asDropDownValue();
        for (var i = 0; i < countryDrdElem.options.length; i++) {
            if (countryDrdElem.options[i].value === countryAsDropDrownValue) {
                countryDrdElem.options[i].selected = true;
                break;
            }
        }
    };

    var chooseSuggestion = function (suggestionElem) {
        suggestionSelected = true;
        zipElem.value = suggestionElem.textContent;
        hideSuggestions();

        if (countryDrdElem.selectedIndex === 0) {
            selectDocumentCountryInDropdown();
        }

        var suggestionId = suggestionElem.getAttribute("data-suggestion-id");
        fetchLatLon(suggestionId);

    };

    var listItemClickEventHandler = function (event) {
        chooseSuggestion(event.target);

    };

    var selectSuggestionItem = function (offset) {
        var suggestions = suggestionsListElem.childNodes;

        var currentIndex = (function () {
            for (var i = 0; i < suggestions.length; i++) {
                var node = suggestions[i];
                if (node.classList.contains(listSuggestionSelectedCssClass)) {
                    return i;
                }
            }
            return -1;
        })();

        var newIndex = currentIndex + offset;
        if (newIndex >= 0 && newIndex < suggestions.length) {
            suggestions[currentIndex].classList.remove(listSuggestionSelectedCssClass);
            suggestions[newIndex].classList.add(listSuggestionSelectedCssClass);
            return suggestions[newIndex];
        } else {
            return suggestions[currentIndex];
        }
    };

    var getKeyCodeFromEvent = function (event) {
        if (window.event) { // IE
            return event.keyCode;
        }

        if (event.which) {
            return event.which;
        }
    };

    var handleZipElemKeyDownAndPressed = function (event) {

        if (!isSelectedCountryEqualDocumentCountry()) {
            return true;
        }

        var preventOnKeycodes = [KEYCODE_RETURN, KEYCODE_UP, KEYCODE_DOWN];
        if (isSuggestionsListVisible() && preventOnKeycodes.indexOf(getKeyCodeFromEvent(event)) !== -1) {
            event.preventDefault();
            event.stopPropagation();
            return false;
        }
    };

    var handleZipElemKeyUp = function (event) {

        if (!isSelectedCountryEqualDocumentCountry()) {
            return true;
        }

        var keyHandled = false;
        if (isSuggestionsListVisible()) {
            switch (getKeyCodeFromEvent(event)) {
                case KEYCODE_DOWN:
                    selectSuggestionItem(1);
                    keyHandled = true;
                    break;
                case KEYCODE_UP:
                    selectSuggestionItem(-1);
                    keyHandled = true;
                    break;
                case KEYCODE_RETURN:
                    var selected = selectSuggestionItem(0);
                    chooseSuggestion(selected);
                    keyHandled = true;
                    break;
                case KEYCODE_ESCAPE:
                    zipElem.value = "";
                    resetSuggestions();
                    keyHandled = true;
                    break;
            }
        } else {
            if (getKeyCodeFromEvent(event) === KEYCODE_RETURN) {
                // don't open suggestion list on submit
                keyHandled = true;
            }
        }

        if (!keyHandled) {
            var zipValue = zipElem.value.trim();
            if (zipValue.length > 0) {
                zipAutoSuggest(zipValue);
            } else {
                resetSuggestions();
            }
        }

        event.preventDefault();
        event.stopPropagation();
        return false;
    };

    var handleZipElemChange = function () {
        if (suggestionSelected) {
            return;
        }
        if (!isSelectedCountryEqualDocumentCountry()) {
            return;
        }

        zipAutoSuggest(zipElem.value.trim());

    };

    var handleBlur = function () {
        if (!isSelectedCountryEqualDocumentCountry()) {
            return;
        }
        if (suggestionsAreHidden()) {
            return;
        }

        if (zipElem.value.trim().length > 0 && suggestionsListElem.childNodes.length > 0) {
            var firstSuggestion = suggestionsListElem.childNodes[0];
            if (zipElem.value !== firstSuggestion.textContent) {
                chooseSuggestion(firstSuggestion);
            }
        }
        hideSuggestions();
    };

    var handleZipKeyDownChangeCountry = function () {
        if (countryDrdElem.selectedIndex === 0) {
            selectDocumentCountryInDropdown();
        }
    };

    if (isAutoSuggestActiveForDocumentCountry() && zipElem) {
        zipElem.addEventListener("keyup", handleZipElemKeyUp);
        zipElem.addEventListener("keydown", handleZipElemKeyDownAndPressed);
        zipElem.addEventListener("keypressed", handleZipElemKeyDownAndPressed);
        zipElem.addEventListener("change", handleZipElemChange);
        zipElem.addEventListener("blur", handleBlur);

        suggestionsListElem.addEventListener("mousedown", listItemClickEventHandler);
    }

    if(zipElem){
        zipElem.addEventListener("keydown", handleZipKeyDownChangeCountry);
    }

};

var init = function(){
    setup("car");
    setup("moto");
};

module.exports = {
    init: init
};
